import { progressTypes } from "../types";

export const asignarPorcentaje = (loaded, total) => {
	return (dispatch) => {
		dispatch({ type: progressTypes.asignarPorcentaje, loaded, total });
	};
};
